<template>
  <div>
    <v-text-field
      :readonly="!canEditOffer"
      outlined
      background-color="#FFFFFF"
      hide-details
      type="number"
      suffix="%"
      v-model.number="inputModel"
      @click="canEditOffer && handleStartEdit()"
      @focus="!canEditOffer && $event.target.blur()"
      @keyup.enter="$event.target.blur()"
      @blur="canEditOffer && handleStopEdit()"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'InputDiscount',
  props: {
    discount: {
      type: String,
    },
  },
  data() {
    return {
      parsedDiscount: 0,
      isEditMode: false,
    }
  },
  computed: {
    ...mapGetters('offer', ['canEditOffer']),
    inputModel: {
      get() {
        return this.isEditMode ? this.parsedDiscount : this.discount
      },
      set(value) {
        this.parsedDiscount = value
        this.$emit('onChangeDiscount', value)
      },
    },
  },
  methods: {
    handleStartEdit() {
      this.isEditMode = true
      this.parsedDiscount = parseFloat(this.discount)
    },
    handleStopEdit() {
      this.isEditMode = false
    },
  },
}
</script>
